import React, { useEffect, useRef } from 'react';
import './CertificationSlider.css';

const CertificationSlider = () => {
  const sliderRef = useRef(null);

  const certifications = [
    {
      id: 1,
      name: 'ISO 22000:2005',
      logo: '/assets/logos/ISO-logo.jpg'
    },
    {
      id: 2,
      name: 'HACCP',
      logo: '/assets/logos/HACCP-ico.jpg'
    },
    {
      id: 4,
      name: 'FSSAI',
      logo: '/assets/logos/FSSAI-ico.jpg'
    },
    {
      id: 5,
      name: 'APEDA',
      logo: '/assets/logos/APEDA-ico.jpg'
    },
    {
      id: 6,
      name: 'MSME',
      logo: '/assets/logos/MSME-ico.jpg'
    },
    {
      id: 7,
      name: 'IOPEPC',
      logo: '/assets/logos/IOPEPC-ico.jpg'
    },
    {
      id: 8,
      name: 'KSSAI',
      logo: '/assets/logos/KSSAI-ico.jpg'
    },
    {
      id: 9,
      name: 'FIEO',
      logo: '/assets/logos/FIEO-logo.jpg'
    }
  ];

  // Duplicate certifications for seamless loop
  const duplicatedCertifications = [...certifications, ...certifications, ...certifications];

  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return;

    let animationId;
    let position = 0;
    const speed = 0.5; // pixels per frame

    const animate = () => {
      position -= speed;
      
      // Calculate the width of one set of certifications (1/3 of total width)
      const singleSetWidth = slider.scrollWidth / 3;
      
      // Reset position when we've scrolled exactly one set width
      // This creates a seamless loop since we have 3 identical sets
      if (position <= -singleSetWidth) {
        position = 0;
      }
      
      slider.style.transform = `translateX(${position}px)`;
      animationId = requestAnimationFrame(animate);
    };

    // Start animation after a small delay to ensure DOM is ready
    const startAnimation = () => {
      animate();
    };

    const timeoutId = setTimeout(startAnimation, 100);

    return () => {
      if (animationId) {
        cancelAnimationFrame(animationId);
      }
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <section className="certification-slider">
      <div className="certification-track" ref={sliderRef}>
        {duplicatedCertifications.map((cert, index) => (
          <div key={`${cert.id}-${index}`} className="certification-item">
            <img 
              src={cert.logo} 
              alt={cert.name}
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
              }}
            />
            <div className="cert-placeholder" style={{ display: 'none' }}>
              <i className="fa fa-certificate"></i>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CertificationSlider;
